import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import ServiceOverlay from "../components/ServiceOverlay";
import axios from 'axios';
import Receipt from "../components/Receipt";

const DashboardOverview = () => {
  const [isServiceOverlayOpen, setIsServiceOverlayOpen] = useState(false);
  const [selectedService, setSelectedService] = useState(null);
  const [user, setUser] = useState(null);
  const [showReceipt, setShowReceipt] = useState(false);
  const [transactionDetails, setTransactionDetails] = useState(null);

  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    const fetchUser = async () => {
      try {

        const token = localStorage.getItem("authToken");
        if (!token) return;
        const response = await axios.get(`${API_BASE_URL}/api/v1/auth/profile`, {
          headers: {
            Authorization: `Bearer ${token}`, // Send token for authentication
          },
        });

        setUser(response.data); // Assuming response contains user data
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    };

    fetchUser();
  }, [ API_BASE_URL]);

  const services = [
    { 
      id: 'airtime', 
      name: 'Airtime VTU', 
      icon: 'phone_android',
      color: 'text-blue-500'
    },
    { 
      id: 'data', 
      name: 'Data Bundle', 
      icon: 'data_usage',
      color: 'text-green-500'
    },
    { 
      id: 'electricity', 
      name: 'Electricity', 
      icon: 'electric_bolt',
      color: 'text-yellow-500'
    },
    { 
      id: 'tv', 
      name: 'TV Subscription', 
      icon: 'tv',
      color: 'text-purple-500'
    },
    { 
      id: 'education', 
      name: 'Education', 
      icon: 'school',
      color: 'text-red-500'
    }
  ];

  const handleServiceClick = (service) => {
    setSelectedService(service);
    setIsServiceOverlayOpen(true);
  };

  return (
    <div className="space-y-6">
      {/* Wallet Balance Section */}
      <div className="bg-white p-4 md:p-8 rounded-lg shadow-md border-l-4 border-emerald-green">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-charcoal-gray text-base md:text-lg">Wallet Balance</p>
            <h3 className="text-3xl md:text-4xl font-bold text-navy mt-1 md:mt-2">
              ₦{Number(user?.virtualAccount?.accountAmount || 0).toLocaleString('en-NG', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              })}
            </h3>
            {/* <p className="text-xs md:text-sm text-charcoal-gray mt-1 md:mt-2">Last transaction: 2 days ago</p> */}
          </div>
          <span className="material-icons text-4xl md:text-5xl text-emerald-green">account_balance_wallet</span>
        </div>
        <div className="mt-4 md:mt-6 flex flex-col sm:flex-row gap-3 md:gap-4">
          <Link 
            to="/dashboard/topup" 
            className="flex-1 bg-emerald-green hover:bg-opacity-90 text-white px-4 md:px-6 py-2.5 md:py-3 rounded-lg transition-colors duration-200 flex items-center justify-center text-sm md:text-base"
          >
            <span className="material-icons mr-2 text-xl md:text-2xl">add</span>
            Top Up Wallet
          </Link>
          <button 
            className="flex-1 bg-navy hover:bg-charcoal-gray text-white px-4 md:px-6 py-2.5 md:py-3 rounded-lg transition-colors duration-200 flex items-center justify-center text-sm md:text-base"
          >
            <span className="material-icons mr-2 text-xl md:text-2xl">send</span>
            Transfer Funds
          </button>
        </div>
      </div>

      {/* Services Grid */}
      <div className="bg-white rounded-lg shadow-md p-6">
        <h2 className="text-xl font-semibold text-navy mb-6">Quick Services</h2>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {services.map((service) => (
            <button
              key={service.id}
              onClick={() => handleServiceClick(service)}
              className="p-6 rounded-lg border-2 border-light-gray hover:border-emerald-green transition-all duration-200 flex flex-col items-center gap-3"
            >
              <span className={`material-icons text-4xl ${service.color}`}>
                {service.icon}
              </span>
              <span className="text-charcoal-gray font-medium text-sm md:text-base">
                {service.name}
              </span>
            </button>
          ))}
        </div>
      </div>

      {/* Service Overlay */}
      {isServiceOverlayOpen && selectedService && (
        <ServiceOverlay
          isOpen={isServiceOverlayOpen}
          onClose={() => setIsServiceOverlayOpen(false)}
          serviceType={selectedService.id}
          setShowReceipt={setShowReceipt}
          setTransactionDetails={setTransactionDetails}
        />
      )}
            {showReceipt && (
        <Receipt 
          showReceipt={showReceipt}
          transactionDetails={transactionDetails}
          setShowReceipt={setShowReceipt}
        />
      )}
    </div>
  );
};

export default DashboardOverview;